import { Configuration } from 'components/Shell/Configuration/Configuration';
import { useRootStore } from 'models/rootModel';
import { Outlet, useParams } from 'react-router-dom';
import { Layout } from '../../components/Layout/Layout';

/**
 * Handles tenant routes and renders each route inside of a tenantId
 */
const TenantHandler = () => {
  const rootStore = useRootStore();
  const { tenantId } = useParams();

  if (rootStore.municipality.tenantId !== tenantId) {
    //TODO Change tenant, fetch settings etc maybe?
    //TODO Check what tenants the user has access to and only set municipality if it exists, otherwise redirect to current tenantId
    if (localStorage && localStorage.rootState) {
      localStorage.removeItem('rootState');
    }
    rootStore.removeAllApplications();
    rootStore.setMunicipality({ tenantId });
  }

  return (
    <Configuration>
      <Layout>
        <Outlet />
      </Layout>
    </Configuration>
  );
};

export default TenantHandler;
